/**
 * Which jobs are still in play.
 *
 * A job is current until it is completed or lost. The Jobs page's Active /
 * Lost / Completed tabs and any job picker that should only offer live work
 * (the treatment's linked job) read these, so the two can't disagree.
 */

export const COMPLETED_JOB_STATUSES = ['completed'];
export const LOST_JOB_STATUSES = ['lost'];

export const isCompletedJob = (job) => COMPLETED_JOB_STATUSES.includes(job?.status);
export const isLostJob = (job) => LOST_JOB_STATUSES.includes(job?.status);
export const isCurrentJob = (job) => !isCompletedJob(job) && !isLostJob(job);
